<div
  class="selfservice-toggle"
  [class.active]="active()"
  [class.disabled]="disabled()"
  [matTooltip]="tooltipText()"
  [matTooltipPosition]="'above'"
  (click)="propagateClick()"
></div>
